import { jsx as _jsx } from "react/jsx-runtime";
import { radius, spacing, colors } from '@mehilainen/mds-tokens';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
// NOTE: Do not import these from lib root! Will cause circular deps
import { CheckCircle, CircleInfo, CircleTimes, ExclamationCircle, } from './icons';
// https://zeroheight.com/095c4083c/v/latest/p/734594-customer
export const customerTokens = {
    uiElementTypography: {
        dropdownRow: baseTypography.size[300].rem,
        selectorModalTitle: baseTypography.size[300].rem,
        datePickerDate: baseTypography.size[300].rem,
        datePickerColumenTitle: baseTypography.size[200].rem,
    },
    uiElementButton: {
        borderRadius: radius[1000].px,
        lightHoverColor: colors.Gray100,
        sizeSmall: {
            fontSize: baseTypography.size[200].rem,
            height: spacing[700].px,
            gap: spacing[300].px,
            padding: spacing[500].px,
            paddingForIcon: spacing[300].px,
        },
        sizeMedium: {
            fontSize: baseTypography.size[300].rem,
            height: spacing[800].px,
            gap: spacing[300].px,
            padding: spacing[500].px,
            paddingForIcon: spacing[300].px,
        },
        sizeLarge: {
            fontSize: baseTypography.size[300].rem,
            height: spacing[900].px,
            gap: spacing[300].px,
            padding: spacing[500].px,
            paddingForIcon: spacing[300].px,
        },
    },
    uiElementInputFields: {
        sizeSmall: {
            notchedLabelFontSize: baseTypography.size[300].rem,
            notchedLabelFontWeight: baseTypography.weight.Regular,
            labelFontSize: baseTypography.size[300].rem,
            labelFontWeight: baseTypography.weight.Medium,
            contentFontSize: baseTypography.size[300].rem,
            assistiveTextSize: baseTypography.size[300].rem,
            assistiveTextWeight: baseTypography.weight.Regular,
            height: spacing[800].rem,
        },
        sizeMedium: {
            notchedLabelFontSize: baseTypography.size[300].rem,
            notchedLabelFontWeight: baseTypography.weight.Regular,
            labelFontSize: baseTypography.size[300].rem,
            labelFontWeight: baseTypography.weight.Medium,
            contentFontSize: baseTypography.size[400].rem,
            assistiveTextSize: baseTypography.size[300].rem,
            assistiveTextWeight: baseTypography.weight.Regular,
            height: spacing[1000].rem,
        },
        common: {
            borderRadius: radius[100].pixels,
            borderColor: colors.Gray500,
            labelColor: colors.Gray900,
            labelFilledColor: colors.Gray900,
            labelFocusedColor: colors.Primary500,
            paddingLeft: 16,
            errorBackground: colors.White,
        },
    },
    uiElementSelections: {
        iconSize: baseTypography.size.icon[500].rem,
        toggleWidth: spacing[700].rem,
        toggleHeight: '19px',
        thumbSize: '11.5px',
        gap: spacing[300].px,
        labelSize: baseTypography.size[400].rem,
        labelWeight: baseTypography.weight.Regular,
        subLabelSize: baseTypography.size[300].rem,
        subLabelWeight: baseTypography.weight.Regular,
    },
    uiElementChip: {
        fontWeight: baseTypography.weight.Medium,
        lineHeight: baseTypography.height.Small,
        borderRadius: radius[1000].px,
        gap: spacing[250].px,
        filled: {
            disabled: {
                backgroundColor: colors.Gray[500],
            },
        },
        outlined: {
            borderWidth: '1px',
            disabled: {
                backgroundColor: colors.White,
                color: colors.Gray[500],
            },
        },
        sizeSmall: {
            height: spacing[600].rem,
            fontSize: baseTypography.size[300].rem,
            padding: spacing[300].rem,
            icons: {
                size: baseTypography.size.icon[100].rem,
            },
        },
        sizeMedium: {
            height: spacing[800].rem,
            fontSize: baseTypography.size[300].rem,
            padding: spacing[500].rem,
            icons: {
                size: baseTypography.size.icon[100].rem,
            },
        },
    },
    uiElementToggleButton: {
        sizeSmall: {
            height: spacing[700].rem,
            fontSize: baseTypography.size[200].rem,
            padding: spacing[300].rem,
        },
        sizeMedium: {
            height: spacing[800].rem,
            fontSize: baseTypography.size[300].rem,
            padding: spacing[300].rem,
        },
        sizeLarge: {
            height: spacing[1000].rem,
            fontSize: baseTypography.size[300].rem,
            padding: spacing[500].rem,
        },
    },
    uiElementTabs: {
        fontSize: baseTypography.size[300].rem,
        lineColor: colors.Primary500,
    },
    uiElementAlert: {
        border: '1px solid',
        borderRadius: radius[200].rem,
        borderColor: {
            Error: colors.Error200,
            Info: colors.Info200,
            Success: colors.Success200,
            Warning: colors.Warning200,
        },
        icon: {
            iconMapping: {
                error: _jsx(CircleTimes, {}),
                info: _jsx(CircleInfo, {}),
                success: _jsx(CheckCircle, {}),
                warning: _jsx(ExclamationCircle, {}),
            },
            bgHeight: 'auto',
            bgWidth: 'auto',
            borderRadius: '0',
            standard: {
                bgColor: {
                    Error: 'transparent',
                    Info: 'transparent',
                    Success: 'transparent',
                    Warning: 'transparent',
                },
                color: {
                    Error: colors.Error500,
                    Info: colors.Info500,
                    Success: colors.Success500,
                    Warning: colors.Warning500,
                },
            },
            filled: {
                bgColor: 'transparent',
                color: {
                    Error: colors.White,
                    Info: colors.White,
                    Success: colors.White,
                    Warning: colors.White,
                },
            },
        },
        lineHeight: baseTypography.height.Large,
        padding: spacing[400].rem,
    },
    uiElementAlertTitle: {
        marginBottom: spacing[200].rem,
    },
    uiElementAccordion: {
        titleFontSize: baseTypography.size[500].rem,
        contentDefaultFontSize: baseTypography.size[400].rem,
        iconSize: spacing[700].rem,
        height: spacing[1100].rem,
    },
    values: {
        inputLabelPlacement: 'standard',
    },
    uiElementLink: {
        hoverColor: {
            primary: colors.Primary[600],
            error: colors.Error[600],
        },
    },
};
